
import { Component, Vue } from 'nuxt-property-decorator'
import IconsMixin from '~/mixins/icons.mixin'

@Component
export default class IconInfo extends IconsMixin {
}
